require('./searchBeneficiaries.scss');

const PropTypes = require('prop-types');

const React = require('react');
// @ commons
const { SLASH } = require ('constants/index');
const { getLastNChars, toCamelCase } = require('utilities/stringHelper');

const AccountItemSelected = props => {
    const { value } = props;
    const contact = value;
    let selectedContent;

    if (contact.value >= 0) {
        const account = (!!contact.iban) ? contact.iban : contact.accountNumber;
        const accountFormatted = getLastNChars(account);
        const fullName = toCamelCase(contact.fullName);
        const alias = contact.alias;

        selectedContent = (
            <div className="Select-value-label">
                <div className="search-contacts__contact-description">
                    <span className="search-contacts__contact-description-name">{fullName}</span>
                    <span className="search-contacts__contact-description-separator"> {SLASH} </span>
                    <span className="search-contacts__contact-description-alias">{alias} </span>
                    <span className="search-contacts__contact-description-iban">{accountFormatted}</span>
                </div>
            </div>
        );
    } else {
        selectedContent = (
            <div className="Select-value-label search-contacts__contact-description">
                <span>{contact.fullName}</span>
            </div>);
    }

    return (
        <div className="Select-value search-contacts__contact clearfix">
            {selectedContent}
        </div>
    );
};

AccountItemSelected.propTypes = {
    value: PropTypes.object
};

module.exports = AccountItemSelected;